import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FavoriteRecord } from '../pages/content-creator/add-content/models/content.model';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class FavoriteRecordsService {

  public favoriteRecordsSubject = new BehaviorSubject<FavoriteRecord[] | null>(null);
  public favroiteCityRecordsSubject = new BehaviorSubject<FavoriteRecord[] | null>(null);
  public favoriteRecords$ = this.favoriteRecordsSubject.asObservable();
  public favroiteCityRecords$ = this.favroiteCityRecordsSubject.asObservable();

  constructor(private dataService: DataService) { }

  public loadFavoriteRecords(userId: number | string, context: 'map' | 'city', force: boolean = false): void {

    if(context === 'map') {
      if (!this.favoriteRecordsSubject.value || force) {
        this.dataService.getFavroiteRecordsByMapId(userId, context).subscribe({
          next: (data: any) => {
            this.favoriteRecordsSubject.next(data);
          },
          error: (err) => {
            console.error('Error fetching favorite records:', err);
            this.favoriteRecordsSubject.next([]);
          }
        });
      }
    } else {

      if (!this.favroiteCityRecordsSubject.value || force) {
        this.dataService.getFavroiteRecordsByMapId(userId, context).subscribe({
          next: (data: any) => {
            this.favroiteCityRecordsSubject.next(data);
          },
          error: (err) => {
            console.error('Error fetching favorite records:', err);
            this.favroiteCityRecordsSubject.next([]);
          }
        });
      }
    }
  }
}
